<template>
  <div>
    <ViolationUpdateDialog v-bind:violation="selected" :state="editViolationState" />
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
      </template>
      <v-list class="pa-0">
        <v-list-item :disabled="!$auth.policies['update-violation']" @click="editViolationState = !editViolationState">
          Sửa nội dung
        </v-list-item>
        <v-list-item :disabled="!$auth.policies['delete-violation']" class="elevation-0" @click="onRemove()">
          Xóa nội dung
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ViolationUpdateDialog from './ViolationUpdateDialog.vue'

export default {
  components: {
    ViolationUpdateDialog,
  },
  props: {
    selected: { type: Object, default: () => [] },
  },
  data() {
    return {
      sending: null,
      editViolationState: false,
    }
  },
  computed: {
    ...mapState('violation', ['violations']),
  },
  methods: {
    ...mapActions('violation', ['removeViolation', 'updateDivision']),
    ...mapActions('ClassNoteDetail', ['deleteViolation']),

    onRemove() {
      this.$dialog.confirm({
        title: 'Xóa',
        text: 'Bạn có chắc muốn xóa nội dung khen thưởng kỷ luật này không?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          this.$loading.active = true
          await this.removeViolation(this.selected.id)
          this.deleteViolation(this.selected.id)
          this.$loading.active = false
        },
      })
    },
  },
}
</script>
